import { render, staticRenderFns } from "./customerDetail.vue?vue&type=template&id=35d19dfb&scoped=true&"
import script from "./customerDetail.vue?vue&type=script&lang=js&"
export * from "./customerDetail.vue?vue&type=script&lang=js&"
import style0 from "./customerDetail.vue?vue&type=style&index=0&id=35d19dfb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d19dfb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35d19dfb')) {
      api.createRecord('35d19dfb', component.options)
    } else {
      api.reload('35d19dfb', component.options)
    }
    module.hot.accept("./customerDetail.vue?vue&type=template&id=35d19dfb&scoped=true&", function () {
      api.rerender('35d19dfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/client/customer/customerDetail.vue"
export default component.exports